import React, { Dispatch, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Tab, Tabs } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useMappedRoles } from 'hooks/useMappedRoles'
import ApiKeys from 'pages/ApiKeys/V2/ApiKeys'
import { WebhooksPage } from '../pages/WebhooksPage'
import { IntegrationsTabsOption, IntegrationsTabsOptions } from '../types'

interface ApprovalTabsProps {
  queryTab: IntegrationsTabsOption
  activeTab: IntegrationsTabsOption
  setActiveTab: Dispatch<React.SetStateAction<string>>
}

const IntegrationsTabs = ({ queryTab, activeTab, setActiveTab }: ApprovalTabsProps) => {
  const { t } = useTranslation()
  const { profile } = useProfileContext()
  const isAccountViewOnly = !!profile?.viewOnly
  const permissions = useMappedRoles()
  const canViewApiIntegration = permissions?.manageApiIntegration?.canView

  const tabs: Tab[] = [
    {
      id: IntegrationsTabsOptions.HOOKS,
      header: t('integrations.webhooks'),
      content: <WebhooksPage />,
    },
  ]

  if (!isAccountViewOnly && canViewApiIntegration) {
    tabs.unshift({
      id: IntegrationsTabsOptions.API_KEYS,
      header: t('integrations.apiKeys'),
      content: <ApiKeys />,
    })
  }

  useEffect(() => {
    if (queryTab) {
      setActiveTab(queryTab)
    }
  }, [queryTab])

  return <Tabs tabs={tabs} defaultTabId={activeTab} />
}

export default IntegrationsTabs
